import './CornerGripperLogo.scss';

interface CornerGripperLogoProps {
  tapToReload: () => void;
}

export default function CornerGripperLogo(props: CornerGripperLogoProps) {
  const { tapToReload } = props;
  return (
    <img
      className="corner-gripper-logo"
      draggable="false"
      src={require('../assets/images/blue_gripper.png')}
      onClick={tapToReload}
      alt={'Small, verdigris Diligent logo.'}
    />
  );
}
